import idx from 'idx'
import Events from '@utilities/events'
import apiErrorHandler from '../api-error-handler'

/**
 * Process errors from API or JS errors
 *
 * @param {Object} error - error message
 */
const errorHandler = function (error) {
  Events.$trigger('loader::hide')
  const data = idx(error, (_) => _.response.data)
  if (data) {
    apiErrorHandler(data)
  } else {
    throw new Error(`JAVASCRIPT ERROR: ${error}`)
  }
}

export default errorHandler
